import styled from '@emotion/styled';
export const FieldSet = styled.div `
  border: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: -16px; // Accounts for the 16px bottom margin on FieldWrapper
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmllbGRTZXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9maWVsZC1zZXQvRmllbGRTZXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sTUFBTSxNQUFNLGlCQUFpQixDQUFDO0FBRXJDLE1BQU0sQ0FBQyxNQUFNLFFBQVEsR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFBOzs7Ozs7Q0FNakMsQ0FBQyJ9